import { MenuItem } from "@mui/material"
import type { MRT_Row } from "material-react-table"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { getEditProductRoute, getEditProductGroupRoute } from "../../../../../../constants/routes"
import type { DefaultConfirmModalStateType } from "./DeleteProductDialog"
import { type ProductTableRow, ProductTableRowType } from "../../productsTypes"

type RenderRowActionMenuItemsProps = {
    row: MRT_Row<ProductTableRow>
    closeMenu: () => void
    setConfirmModalState: React.Dispatch<React.SetStateAction<DefaultConfirmModalStateType>>
    navigate: (path: string) => void
    errorClasses?: string
    onDeleteGroup?: (groupId: number, groupName: string) => void
}

export const renderRowActionMenuItems = ({
    row,
    closeMenu,
    setConfirmModalState,
    navigate,
    errorClasses,
    onDeleteGroup,
}: RenderRowActionMenuItemsProps) => {
    if (row.original.type === ProductTableRowType.GROUP) {
        return [
            <LocalizedStrict id="products-edit-product-group-menu-item" key={`edit-group-${row.original.id}`}>
                <MenuItem
                    onClick={() => {
                        navigate(getEditProductGroupRoute(row.original.id))
                        closeMenu()
                    }}
                >
                    Edit
                </MenuItem>
            </LocalizedStrict>,
            ...(onDeleteGroup
                ? [
                      <LocalizedStrict id="products-delete-product-group-menu-item" key={`delete-group-${row.original.id}`}>
                          <MenuItem
                              className={errorClasses}
                              onClick={() => {
                                  onDeleteGroup(row.original.id, row.original.name)
                                  closeMenu()
                              }}
                          >
                              Delete
                          </MenuItem>
                      </LocalizedStrict>,
                  ]
                : []),
        ]
    }

    return [
        <LocalizedStrict id="products-edit-product-menu-item" key={`edit-${row.original.id}`}>
            <MenuItem
                onClick={() => {
                    navigate(getEditProductRoute(row.original.id))
                    closeMenu()
                }}
            >
                Edit
            </MenuItem>
        </LocalizedStrict>,
        <LocalizedStrict id="products-delete-product-menu-item" key={`delete-${row.original.id}`}>
            <MenuItem
                className={errorClasses}
                onClick={() => {
                    setConfirmModalState({
                        showConfirmModal: true,
                        confirmModalText: `${row.original.name}`,
                        productId: row.original.id,
                    })
                    closeMenu()
                }}
            >
                Delete
            </MenuItem>
        </LocalizedStrict>,
    ]
}
